import { PaneArea } from '../../types/shared'
import FR, { IFibonacciRetracementsAttrs } from '../canvas/fibonacci_retracements'
import PaneModel from '../models/pane'

type Area = PaneArea
type Attrs = IFibonacciRetracementsAttrs
type PartialAttrs = Partial<Attrs>

class FRCreator extends FR<Attrs> {
  mouseDowns = 1
  isCreator = true
  curvePoints = 1

  constructor(startArea: Area, values: PartialAttrs, model: PaneModel, _: unknown, toolsCallback: () => void) {
    super(values, model)

    this.attrs.x1 = this.attrs.x2 = startArea.x
    this.attrs.y1 = this.attrs.y2 = startArea.y
    this.mouseDowns = 1
    this.toolsCallback = toolsCallback

    window.gtag?.('event', 'create', { event_category: 'tools', event_label: this.name })
  }

  onMouseDown(area: PaneArea) {
    this.mouseDowns++
    if (this.mouseDowns > 1) {
      this.attrs.x2 = area.x
      this.attrs.y2 = area.y
      this.release()
      this.replaceMyself(FR.fromObject<FR>(this.attrs, this.model))
      this.toolsCallback()
    }
  }

  onMouseMove(area: Area) {
    this.attrs.x2 = area.x
    this.attrs.y2 = area.y
    this.trigger('change')
  }
}

export default FRCreator
